import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
  ariaHidden?: boolean;
  ariaLabel?: string;
}

/** Clockwise arrow — the image-preview "rotate right" control. */
const IconRotateRight: React.FC<IconProps> = ({
  size = 18,
  className,
  ariaHidden = true,
  ariaLabel,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden={ariaHidden ? true : undefined}
    aria-label={ariaLabel}
  >
    <path d="M20 4v6h-6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M20 10a8 8 0 1 0-2 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

export default IconRotateRight;
